module.exports = __webpack_public_path__ + "img/mobile_app_promo.bc23a317.png";